<div class="selectedMenuItem">
    <p>You're reporting: <strong>{{getSelectedMenuName()}}</strong></p>
</div>

<h2>Where is the problem?</h2>

<!-- <p class="locationSearchInfo" [class.preNextErrorLabel]="isErrorPresentOnPage">Enter the location in the search bar or set it on the map.</p> -->
<p class="locationSearchInfo">Enter the location in the search bar or set it on the map.</p>

<p *ngIf="isErrorPresentOnPage" class="preNextErrorLabel">Please enter a location.</p>
<p class="locationSearchError" id="searchErrorDisplay"></p>

<div class="locationContainer">

    <div class="mapSelection">
        <div class="mapView">
            <div id="map" class="map"></div>

            <!-- <ng-container *ngIf="isMobile.any()">
                <div id="markerIcon">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                         version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">
                        <desc>Created with Fabric.js 1.7.22</desc>
                        <defs>
                        </defs>
                        <g transform="translate(128 128) scale(0.72 0.72)">
                            <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(-175.05 -175.05000000000004) scale(3.89 3.89)" >
                            <path class="draggable" d="M 45 0 C 32.957 0 23.159 9.798 23.159 21.841 c 0 11.369 8.732 20.732 19.841 21.746 V 88 c 0 1.104 0.896 2 2 2 s 2 -0.896 2 -2 V 43.587 c 11.109 -1.014 19.841 -10.377 19.841 -21.746 C 66.841 9.798 57.043 0 45 0 z M 50.863 20.5 c -3.032 0 -5.5 -2.467 -5.5 -5.5 c 0 -3.033 2.467 -5.5 5.5 -5.5 c 3.032 0 5.5 2.467 5.5 5.5 C 56.364 18.033 53.896 20.5 50.863 20.5 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                        </g>
                        </g>
                    </svg>
                </div>
            </ng-container> -->
            <div *ngIf="this.getSelectedMenuName() === 'Streets and sidewalks > Icy or snowy street'" class="legend">
                <div class="title">Street priority legend</div>
                <div class="legend-content">
                    <div class="legend-row" *ngFor="let info of snowLegendInfo; let i = index"><div class="square" [ngStyle]="{'background-color': 'rgba(' + info.symbol.color.toString() + ')'}"></div><div class="squareDescription"> {{info.label}} (within {{6*((i+1)*(i+1)) + (18*(i+1)) - 12}}h)</div></div>
                </div>
            </div>
        </div>
    </div>

    <div class="searchContainer">

        <div class="searchField">
            <input type="text" [class.preNextErrorInput]="isErrorPresentOnPage" [(ngModel)]="searchFieldText"
                id="locationSearchField" class="smallDisplayOnlyInput" name="locationSearchField"
                placeholder='1370 Crown St' autocomplete="off" (input)="handleTextUpdate()" maxlength="300">

            <ng-container *ngIf="itemsMap.length > 0">
                <div class="inputAutocomplete">
                    <div class="emptyItemTop"></div>
                    <ng-container *ngFor="let item of itemsMap">
                        <div class="item" (click)="handleItemClick(item)">{{item.name}}</div>
                    </ng-container>
                    <div class="emptyItemBottom"></div>
                </div>
            </ng-container>

            <div class="searchIcon">
                <svg version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="27px" height="25px"
                    xmlns="http://www.w3.org/2000/svg">
                    <g transform="matrix(1 0 0 1 -39 -422 )">
                        <path
                            d="M 25.924383544921874 24.771093750000002  C 26.2353515625 24.4677734375  26.2353515625 23.9697265625  25.92388916015625 23.6669921875  L 18.9283447265625 16.7578125  C 20.4708251953125 14.98046875  21.36566162109375 12.6806640625  21.36566162109375 10.15625  C 21.36566162109375 4.5458984375  16.761456298828126 0  11.082458496093752 0  C 5.403460693359376 0  0.8437401123046876 4.547363281249999  0.8437401123046876 10.15625  C 0.8437401123046876 15.76513671875  5.447460937500001 20.3125  11.08245849609375 20.3125  C 13.63743896484375 20.3125  15.969451904296875 19.38671875  17.766540527343746 17.86376953125  L 24.762084960937496 24.77294921875  C 24.9598388671875 24.921875  25.16253662109375 25  25.365234375 25  C 25.56793212890625 25  25.770036621093748 24.923730468749998  25.924383544921874 24.771093750000002  Z M 19.828125 10.15625  C 19.828125 14.936523437499998  15.9224853515625 18.75  11.126953125 18.75  C 6.28692626953125 18.75  2.42578125 14.892578125  2.42578125 10.15625  C 2.42578125 5.419921875  6.28692626953125 1.5625  11.126953125 1.5625  C 15.96697998046875 1.5625  19.828125 5.3759765625  19.828125 10.15625  Z "
                            fill-rule="nonzero" fill="#333333" stroke="none" transform="matrix(1 0 0 1 39 422 )" />
                    </g>
                </svg>
            </div>
        </div>
    </div>

</div>